// Pagina delle notifiche

import React from 'react';
import { useAppContext } from '../context/AppContext';
import NotificationList from '../components/notifications/NotificationList';
import './NotificationsPage.css';

const NotificationsPage: React.FC = () => {
    const { state } = useAppContext();

    const handleDismiss = (id: string) => {
        // Implementare la logica di eliminazione
        console.log('Elimina notifica con ID:', id);
    };

    return (
        <div className="notifications-page">
            <h1>Notifiche</h1>
            <NotificationList
                notifications={state.notifications}
                onDismiss={handleDismiss}
            />
        </div>
    );
};

export default NotificationsPage;
